import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PoslovneFinansije() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Poslovne finansije" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Poslovne finansije</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Poslovne finansije
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 6
              </p>
              <p>
                <strong>Uslov:</strong> Računovodstvo
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta je da studentima predstavi ulogu, značaj i
                postupke u okviru poslovnih finansija u upravljanju preduzećem.
                Predmet nudi studentima teoretska i praktična znanja za
                ovladavanje postupcima i metodama upravljanja finansijama
                preduzeća kako bi preduzeće ostvarilo dobar prinosni finansijski
                i imovinski položaj, a da pri tome zadrži trajnu sposobnost
                plaćanja, finansiranja, investiranja i povećanja imovine
                vlasnika. Krajnji cilj nakon završetka ovog kursa jeste da
                studenti budu osposobljeni da u organizacijama u kojima budu
                radili mogu da iskoriste svoje predznanje i praktične vještine
                koje su izučavali tako što će moći brzo da prepoznaju finansije
                i finansijsku politiku preduzeća, da se uključe u poslove bez
                posebnih priprema, da steknu sopstveno mišljenje, kritički stav
                i viđenje upravljanja finansijama.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješnog završetka ovog programskog sadržaja studenti su
                osposobljeni da vladaju teoretskim i praktičnim znanjima koja su
                vezana za pravila i politiku finansiranja, tržišta novca i
                kapitala, načinima finansiranja preduzeća i izboru optimalnih
                izvora, finansijskom planiranju, analizi prinosnog, imovinskog i
                finansijskog položaja preduzeća, ocjenu kreditnog boniteta
                preduzeća, strategiji i taktici upravljanja finansijama u
                preduzeću, investicionim projektima i restrukturiranju
                preduzeća. Ova znanja omogućavaju studentima da se brzo uklope u
                praksu, da brzo ovladaju vještinama iz oblasti poslovnih
                finansija, da razviju timski rad i pun lični doprinos.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>Teorijska nastava:</p>
              <ul>
                <li>
                  Finansije i finansijska politika, pravila finansiranja;
                  Finansijski izveštaji preduzeća; Finansijsko tržište i
                  portfolio hartija od vrijednosti; Finansiranje preduzeća:
                  samofinansiranje, zajedničko ulaganje, kreditiranje,
                  specifični oblici finansiranja; Analiza prinosnog i imovinskog
                  položaja preduzeća; Analiza finansijskog položaja preduzeća i
                  ocjena kreditnog boniteta; Finansijsko planiranje; Poslovni
                  finansijski i ukupan rizik iz poslovanja preduzeća; Bilans
                  novčanih tokova, neto obrtni kapital, dinamično planiranje
                  priliva i odliva gotovine; Investicioni projekti; Finansijska
                  ocjena i rangiranje investicionih projekata; Strategija i
                  taktika upravljanja: trajnim dugoročnim kapitalom i stalnom
                  imovinom, obrtnom imovinom i kratkoročnim finansijskim
                  obavezama, obavezama prema dobavljačima; Segmentiranje
                  preduzeća; Restrukturiranje, stečaj i likvidacija preduzeća.
                </li>
              </ul>
              <p>Praktična nastava prati teorijsku nastavu.</p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se izvode uz korišćenje „Power Point“-a, prezentacija
                i dodatna objašnjenja profesora. Praktična nastava prati
                teorijska predavanja i podrazumijeva: interaktivni rad,
                pojedinačne i grupne prezentacije, analizu praktičnih slučajeva
                uz primjenu finansijskih metoda i tehnika. Predviđeno je
                nekoliko gostujućih predavanja – profesionalaca u oblasti
                poslovnih finansija i tržišta hartija od vrijednosti,
                predstavnika poznatih kompanija, agencija i sl.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Finansije i finansijska politika, pravila finansiranja
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Finansijski izvještaji preduzeća; Finansijsko tržište i
                      portfolio hartija od vrijednosti
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Finansiranje preduzeća: samofinansiranje, zajedničko
                      ulaganje, kreditiranje, specifični oblici finansiranja
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>Analiza prinosnog i imovinskog položaja preduzeća</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Analiza finansijskog položaja preduzeća i ocjena kreditnog
                      boniteta
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>
                      Finansijsko planiranje; Poslovni finansijski i ukupan
                      rizik iz poslovanja preduzeća
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Bilans novčanih tokova, neto obrtni kapital, dinamično
                      planiranje priliva i odliva gotovine
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>Investicioni projekti</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>
                      Finansijska ocjena i rangiranje investicionih projekata
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>
                      Strategija i taktika upravljanja: trajnim dugoročnim
                      kapitalom i stalnom imovinom, obrtnom imovinom
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Strategija i taktika upravljanja: kratkoročnim
                      finansijskim obavezama, obavezama prema dobavljačima
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>Segmentiranje preduzeća</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>Restrukturiranje, stečaj i likvidacija preduzeća</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 430 h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 300 h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PoslovneFinansije;
